import request from '@/request/ts-index';
var SubjectApi;
(function (SubjectApi) {
    SubjectApi["queryTopicDraft"] = "/querySubjectDraft";
    SubjectApi["queryTopic"] = "/querySubject";
    SubjectApi["queryTopic2"] = "/querySubject2";
})(SubjectApi || (SubjectApi = {}));
// 专题草稿
export const queryTopicDraft = (params) => {
    return request.get(SubjectApi.queryTopicDraft, {
        params
    });
};
// 专题
export const queryTopic = (params) => {
    return request.get(SubjectApi.queryTopic, {
        params
    });
};
// 新分类使用 多个专题数据
export const queryTopic2 = (params) => {
    return request.get(SubjectApi.queryTopic2, {
        params
    });
};
